import { userManager } from "../config/authConfig";

export async function getToken() {
  const user = await userManager.getUser();
  if (!user || user.expired) {
    throw new Error("No active session");
  }
  return user.id_token;
}

export async function getPracticeId() {
  const user = await userManager.getUser();
  if (!user || user.expired) {
    return null;
  }
  return user.profile["custom:practice_id"] || null;
}
